import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPageHeatMapFrame.module.less'
import PdfPage, { PageHeader } from '../PdfPage/PdfPage'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import cls from 'classnames'
import { isPortraitByProjectInfo } from '@/helpers/productCategory'

interface Props {
  project: ProjectModels.ProjectDetail
  heatMaps: Array<{ heatMap: string; second: number }>
  onRendered: (cnt: number) => void
  no: number
}

function PdfPageHeatMapFrame({ project, heatMaps, onRendered, no }: Props) {
  const { t } = useTranslation()
  const [images, setImages] = useState<boolean[]>(heatMaps.map(() => false))
  const isPortraitLayout = isPortraitByProjectInfo(project)
  useEffect(() => {
    if (images.every((image) => image)) {
      onRendered(1)
    }
  }, [images])
  return (
    <PdfPage
      bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-heat-map/PDF-heat-map-bg.jpg')}
      no={no}
    >
      <div className={styles.pdfPageHeatMapFrame}>
        <PageHeader
          project={project}
          text={'04.' + t('dashboard.projectDetailPage.heatmapAnalysis')}
        />
        <div className={cls(styles.content, { [styles.portraitContent]: isPortraitLayout })}>
          {heatMaps.map((hm, index) => {
            return (
              <div key={hm.heatMap} className={styles.item}>
                <p className={styles.title}>{hm.second}S</p>
                <img
                  className={styles.image}
                  src={hm.heatMap}
                  onLoad={() => {
                    setImages((prev) => {
                      const newImages = [...prev]
                      newImages[index] = true
                      return newImages
                    })
                  }}
                />
              </div>
            )
          })}
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPageHeatMapFrame
